import { render, staticRenderFns } from "./TreatPanel.vue?vue&type=template&id=9e490454&"
import script from "./TreatPanel.vue?vue&type=script&lang=js&"
export * from "./TreatPanel.vue?vue&type=script&lang=js&"
import style0 from "./TreatPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports